import type { LocaleInfo } from '@az3fr/core';
import type { PayloadAction, Slice } from '@reduxjs/toolkit';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

const localeAdapter = createEntityAdapter<LocaleInfo>();

interface LocaleSliceState {
	ids: string[];
	entities: {
		[key: string]: LocaleInfo;
	};
	activeLocaleId: string | undefined;
}

const initialState: LocaleSliceState = localeAdapter.getInitialState({
	activeLocaleId: undefined,
});

const localeSlice: Slice<LocaleSliceState> = createSlice({
	name: 'entities/locale',
	initialState,
	reducers: {
		activeLocaleIdSet: (state, action: PayloadAction<string>) => {
			state.activeLocaleId = action.payload;
		},
		setAll: localeAdapter.setAll,
	},
});

const localeSliceReducer = localeSlice.reducer;
const localeSliceActions = { ...localeSlice.actions };

export { localeSliceActions, localeSliceReducer, localeAdapter };
export type { LocaleSliceState };
